/** Strip trailing teaser ellipses (… or ...) often copied from list pages though the title is complete. */
export function stripTrailingNewsEllipsis(s: string): string {
  return s.replace(/\s*(\.{3,}|…)\s*$/u, "").trim();
}
